import React, { useEffect, useState } from 'react';
import { bool, shape, string } from 'prop-types';
import { VARIANT_TYPE_CHANGED } from '../../constants/index';
import { onLifeCycleEvent } from '../../utils/product-bundle-utils';
import { BundleAlertmessage } from './BundleAlertmessage';

const BundleVariantChangeAlert = ({
  alertSize,
  alertBodyText,
  alertHeadline,
  product,
  showPageLevelAlert,
  bundleProduct
}) => {
  const { fuelTypeChangeAlert } = bundleProduct?.features || {};

  const [alertBody, setalertBody] = useState(null);

  useEffect(() => {
    onLifeCycleEvent(VARIANT_TYPE_CHANGED, ({ output }) => {
      const { selectedFuelTypeId } = output || {};
      if (showPageLevelAlert || product?.itemId === selectedFuelTypeId) {
        setalertBody(alertBodyText);
      }
    });
  }, []);

  if (!alertBody || !fuelTypeChangeAlert) {
    return null;
  }

  return (
    <div data-component="BundleVariantChangeAlert">
      <BundleAlertmessage
        bundleProduct={product}
        alertSize={alertSize}
        alertBodyText={alertBody}
        alertHeadline={alertHeadline}
        showCloseAlertButton
      />
    </div>
  );
};

BundleVariantChangeAlert.propTypes = {
  alertSize: string,
  alertBodyText: string,
  alertHeadline: string,
  product: shape({}),
  showPageLevelAlert: bool,
  bundleProduct: shape({}).isRequired
};

BundleVariantChangeAlert.defaultProps = {
  alertBodyText: null,
  alertHeadline: null,
  alertSize: 'small',
  product: null,
  showPageLevelAlert: false
};

BundleVariantChangeAlert.displayName = 'BundleVariantChangeAlert';

export { BundleVariantChangeAlert };